<template>
  <main id="js-page-content" role="main" class="page-content">
    <div class="row">
      <div class="subheader col-6">
        <h1 class="subheader-title">請求書NR取得</h1>
      </div>
      <!-- Right content on content header A nice area to add graphs or buttons -->
      <div class="subheader-block ml-auto demo"></div>
    </div>
    <!-- Your main content goes below here: -->
    <div class="row">
      <div class="col-xl-12">
        <div id="panel-1" class="panel">
          <div class="panel-hdr">
            <h2>NR取得</h2>
            <div class="panel-toolbar">
              <button
                class="btn btn-panel"
                data-action="panel-collapse"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Collapse"
              ></button>
              <button
                class="btn btn-panel"
                data-action="panel-fullscreen"
                data-toggle="tooltip"
                data-offset="0,10"
                data-original-title="Fullscreen"
              ></button>
            </div>
          </div>
          <div class="panel-container show" id="panel-search">
            <div class="loader">
              <i class="fal fa-spinner-third fa-spin-4x fs-xxl"></i>
            </div>
            <div class="panel-content contents">
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">案件番号</div>
                <div class="col-md-11 contCnt selectedClear">
                  <vSelect :options="opProjectNumber"></vSelect>
                </div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">請求番号</div>
                <div class="col-md-11 contTitle">メモ</div>
              </div>
              <!-------------------->
              <div class="row">
                <div class="col-md-1 contTitle">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    maxlength="10"
                    disabled
                  />
                </div>
                <div class="col-md-11 contCnt">
                  <input type="text" class="form-control form-control-sm" />
                </div>
              </div>
              <!-------------------->
              <div class="row mt-5 ml-auto">
                <button
                  type="button"
                  class="btn btn-secondary waves-effect waves-themed"
                >
                  請求番号欄追加
                </button>
              </div>
              <!-------------------->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- エラー確認モーダル -->
    <!-- エラー確認モーダル -->
  </main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import "vue-good-table-next/dist/vue-good-table-next.css";
import { VueGoodTable } from "vue-good-table-next";
import Mo_modal_alert from "@/components/molecules/Mo_modal_alert.vue";

@Options({
  components: {
    vSelect,
    VueGoodTable,
    Mo_modal_alert,
  },
})
export default class InvoiceNumberAssignment extends Vue {
  opProjectNumber = [
    { label: "620857：【大阪】丸野商事/小川清秀_62期", code: 620857 },
    {
      label: "620858：【大阪】ブシロード／アニメイト大阪日本橋北面差し替え工事",
      code: 620858,
    },
    {
      label: "620859：【大阪】桜橋深川ビル クマシュー工務店意匠製作取付工事",
      code: 620859,
    },
  ];
}
</script>
